import ChannelDescriptionCrew from './channelListCrewItem';
import ChannelDescriptionCrewContainer from '../../atoms/container/channelListCrewContainer';

export default function ChannelListCrew() {
  return (
    <ChannelDescriptionCrewContainer id={'channelCrewContainer'}>
      <ChannelDescriptionCrew type={'hosts'} title={'MISC.CREW.HOSTS'} />
      <ChannelDescriptionCrew
        type={'directors'}
        title={'MISC.CREW.DIRECTORS'}
      />
      <ChannelDescriptionCrew type={'actors'} title={'MISC.CREW.ACTORS'} />
    </ChannelDescriptionCrewContainer>
  );
}
